import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Globe, MessageCircle } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-3'
    }`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src="/logo.png" alt="KEEN WISDOM" className="h-20 w-auto mix-blend-multiply" style={{ filter: 'contrast(1.05)' }} />
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollToSection('about')} className="text-navy-800 hover:text-gold-600 transition-colors font-medium">
            {t.nav.about}
          </button>
          <button onClick={() => scrollToSection('services')} className="text-navy-800 hover:text-gold-600 transition-colors font-medium">
            {t.nav.services}
          </button>
          <button onClick={() => scrollToSection('team')} className="text-navy-800 hover:text-gold-600 transition-colors font-medium">
            {t.nav.team}
          </button>
          <button onClick={() => scrollToSection('gallery')} className="text-navy-800 hover:text-gold-600 transition-colors font-medium">
            {t.nav.gallery}
          </button>
          <button onClick={() => scrollToSection('contact')} className="text-navy-800 hover:text-gold-600 transition-colors font-medium">
            {t.nav.contact}
          </button>
        </nav>

        <div className="flex items-center gap-4">
          <button
            onClick={toggleLanguage}
            className="flex items-center gap-2 px-3 py-2 rounded-lg border border-navy-200 hover:border-gold-500 hover:bg-gold-50 transition-all"
          >
            <Globe size={18} className="text-navy-700" />
            <span className="text-sm font-medium text-navy-700">{language === 'en' ? 'EN' : '中文'}</span>
          </button>

          <a
            href="https://wa.me/85296586641"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2 bg-navy-700 hover:bg-gold-600 text-white rounded-lg transition-all shadow-md hover:shadow-lg"
          >
            <MessageCircle size={18} />
            <span className="hidden sm:inline text-sm font-medium">{t.whatsapp}</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;